angular.module('impactx.invoice').controller('InvoiceLoadTemplateCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'headerLabel',
    'confirmLabel',
    'abortLabel',
    'requiredLabel',
    'noSelectedItemMessage',
    'deleteLabel',
    'receiverCompanyId',
    'dataGen',
    InvoiceLoadTemplateCtrl]);

function InvoiceLoadTemplateCtrl($scope, $mdDialog, themeFactory, headerLabel, confirmLabel, abortLabel, requiredLabel,
                                 noSelectedItemMessage, deleteLabel, receiverCompanyId, dataGen)
{
    var ctrl = this;
    $scope.required = true;
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.headerLabel = headerLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.deleteLabel = deleteLabel;
    $scope.theme = themeFactory.getTheme();
    dataGen.getData($scope, {receiverCompanyId: receiverCompanyId}, "/invoice/loadtemplates");
    this.delete = function ()
    {
        dataGen.getData($scope, {templateId: $scope.data.selected.id, receiverCompanyId: receiverCompanyId}, "/invoice/deletetemplate");
    };
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.confirm = function ()
    {
        $mdDialog.hide({
            templateId: $scope.data.selected.id
        });
    };
}